import React, { useState } from 'react';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import { withStyles, Button, Select, FormControl, MenuItem } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { getConsentValue } from 'components/business/consents/ConsentsTable';
import axiosClient from '../../http/axios-client';
import AppIconDelete from './app-icons/AppIconDelete';
import AppIconView from './app-icons/AppIconView';
import AppIconEdit from './app-icons/AppIconEdit';
import AdvancedFilters from './AdvancedFilters';
import { getTheme } from '../../theme';

const StyledTableCell = withStyles((theme) => {
  return {
    head: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  };
})(TableCell);

const StyledTableRow = withStyles((theme) => {
  return {
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.alternate.light,
      },
    },
  };
})(TableRow);

// eslint-disable-next-line no-unused-vars
const DoneOrButton = ({ field, value, serial, refetch, setShowLoader }) => {
  // let url;

  // if ('polygenic_risk_available' === field) {
  //   url = `edag/score/${ serial }`;
  // } else if ('dynamic_report_available' === field || 'pdf_available' === field) {
  //   url = `registration-kits/createReports/${ serial }`;
  // }

  return (
    <div style={ { display: 'flex', justifyContent: 'center' } }>
      { value === true && (
        <CheckIcon style={ { color: '#93C120' } } />
      )}

      {/* {
        (null == value || false === value) && 'health_data_available' !== field && (
          <Button
            color='secondary'
            variant='outlined'
            onClick={ () => {
              setShowLoader(true);
              axiosClient.post(url).catch(() => {
                console.log('Error');
              }).finally();
              refetch().then(() => {
                setShowLoader(false);
              });
            } }
          >
            Change Value
          </Button>
        )
      } */}

      {
        (value == null || value === false) && (
          // <IconButton
          //   onClick={ () => {
          //     setShowLoader(true);
          //     axiosClient.post(url).catch(() => {
          //       console.log('Error');
          //     }).finally();
          //     refetch().then(() => {
          //       setShowLoader(false);
          //     });
          //   } }
          // >
          <ClearIcon style={ { color: 'red' } } />
        )
      }
    </div>
  );
};

function descendingComparator(a, b, orderBy) {
  const deepSelectorA = orderBy.split('.').reduce((acc, selector) => {
    return acc?.[selector];
  }, a);
  const deepSelectorB = orderBy.split('.').reduce((acc, selector) => {
    return acc?.[selector];
  }, b);
  if (deepSelectorB < deepSelectorA) {
    return -1;
  }
  if (deepSelectorB > deepSelectorA) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => {
      return descendingComparator(a, b, orderBy);
    }
    : (a, b) => {
      return -descendingComparator(a, b, orderBy);
    };
}

function stableSort(array, comparator) {
  if (!array) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => {
    return [ el, index ];
  });
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => {
    return el[0];
  });
}

function EnhancedTableHead(props) {
  const {
    classes,
    columns,
    order,
    orderBy,
    onRequestSort,
    showCheckbox,
  } = props;
  const createSortHandler = (property) => {
    return (event) => {
      onRequestSort(event, property);
    };
  };

  return (
    <TableHead>
      <StyledTableRow>
        {showCheckbox && (
          <StyledTableCell padding='checkbox' />
        )}
        {columns.map((col) => {
          if (col.noSort === true) {
            return (
              <StyledTableCell
                align='center'
                padding='default'
                key={ col.id }
                style={ {
                  minWidth: col.label === 'Registration Status' ? '200px' : '',
                } }
              >
                {col.label}
              </StyledTableCell>
            );
          }

          return (
            <StyledTableCell
              key={ col.id }
              align='left'
              padding='default'
              sortDirection={ orderBy === col.field ? order : false }
            >
              <TableSortLabel
                active={ orderBy === col.field }
                direction={ orderBy === col.field ? order : 'asc' }
                onClick={ createSortHandler(col.field) }
              >
                {col.label}
                {orderBy === col.id ? (
                  <span className={ classes.visuallyHidden }>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </span>
                ) : null}
              </TableSortLabel>
            </StyledTableCell>
          );
        })}
        {
          props.showActions && (
            <StyledTableCell align='right' padding='default'>
              Actions
            </StyledTableCell>
          )
        }
      </StyledTableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf([ 'asc', 'desc' ]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const EnhancedTableToolbar = (props) => {
  const { advancedFiltersProps } = props;

  return (
    <Grid container spacing={ 2 }>
      <Grid item xs={ 12 } container>
        {
          (advancedFiltersProps) ? (
            <Grid container>
              <AdvancedFilters
                properties={ advancedFiltersProps.properties }
                initialAndFilterOptions={ advancedFiltersProps.initialAndFilterOptions }
                onQueryChange={ advancedFiltersProps.onQueryChange }
              />
            </Grid>
          ) : null
        }
      </Grid>
    </Grid>
  );
};

const SerialPaymentDropdown = ({ row, updateSerial, field }) => {
  return (
    <Select
      style={ { minWidth: '80px' } }
      displayEmpty
      value={ row[field] }
      onChange={ (e) => {
        updateSerial({ id: row.id,
          payload: { [field]: e.target.value } });
      } }
    >
      <MenuItem value='unpaid'>unpaid</MenuItem>
      <MenuItem value='free'>free</MenuItem>
      <MenuItem value='paid'>paid</MenuItem>
      <MenuItem value={ null }>none</MenuItem>
    </Select>
  );
};

EnhancedTableToolbar.propTypes = {
  advancedFiltersProps: PropTypes.object.isRequired,
};

const useStyles = makeStyles((theme) => {
  return {
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
      marginBottom: theme.spacing(2),
    },
    table: {
      // minWidth: 750,
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
  };
});

export default function AppTable(props) {
  const {
    data: rows,
    refetch,
    columns,
    loading,
    paginationProps: {
      page,
      limit,
      sort: {
        order,
        orderBy,
      },
      setPage,
      setLimit,
      setSort,
      count,
    },
    advancedFiltersProps,
    selectionProps,
    activeProps,
  } = props;

  const classes = useStyles();

  const [ showLoader, setShowLoader ] = useState(false);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setSort(property, isAsc ? 'desc' : 'asc');
  };

  const viewPDF = (row, fileEnd) => {
    setShowLoader(true);
    axiosClient.get(`readPDFFile?fileName=${ row.serial_number_id.serial }${ fileEnd }`).then((resp) => {
      const u8 = new Uint8Array(resp.Body.data);
      const blob = new Blob([ u8 ], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('target', '_blank');
      link.click();
    }).catch(() => {
      setShowLoader(false);
    }).finally(() => {
      refetch().then(() => {
        setShowLoader(false);
      });
    });
  };

  const handleClick = (event, name) => {
    const { selected, setSelected } = selectionProps;
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const isSelected = (name) => {
    if (!selectionProps) {
      return false;
    }
    const { selected } = selectionProps;
    return selected.indexOf(name) !== -1;
  };

  const isActive = (name) => {
    if (!activeProps) {
      return false;
    }
    const { active } = activeProps;
    return active.indexOf(name) !== -1;
  };

  const showActions = [
    props.ViewProp?.handleView,
    props.EditProp?.handleEdit,
    props.DelProp?.handleDelete,
  ].some((handler) => {
    return handler !== undefined;
  });

  const showCheckbox = !!selectionProps;
  return (
    <div className={ classes.root }>
      <Paper className={ classes.paper }>
        <EnhancedTableToolbar
          advancedFiltersProps={ advancedFiltersProps }
        />
        <TableContainer>
          <Table
            className={ classes.table }
            aria-labelledby='tableTitle'
            size='small'
            aria-label='enhanced table'
          >
            <EnhancedTableHead
              classes={ classes }
              columns={ columns }
              order={ order }
              orderBy={ orderBy }
              onRequestSort={ handleRequestSort }
              rowCount={ rows?.length }
              showActions={ showActions }
              showCheckbox={ showCheckbox }
            />
            {
              showLoader || loading ? (
                <tbody style={ { display: 'table-row-group', verticalAlign: 'middle' } }>
                  <tr>
                    <td colSpan={ 1000 }>
                      {
                        Array.from(Array(limit).keys()).map((n) => {
                          return (
                            <Skeleton
                              style={ { margin: '16px 12px' } }
                              variant='rectangular'
                              height='16px'
                              key={ n }
                              animation='wave'
                            />
                          );
                        })
                      }
                    </td>
                  </tr>
                </tbody>
              ) : (
                <TableBody>
                  {stableSort(rows, getComparator(order, orderBy))
                    .map((row, index) => {
                      const isItemSelected = isSelected(row.id);
                      const isItemActive = isActive(row.id);
                      const labelId = `enhanced-table-checkbox-${ index }`;

                      return (
                        <StyledTableRow
                          hover
                          role='checkbox'
                          aria-checked={ isItemSelected }
                          tabIndex={ -1 }
                          key={ row.id }
                          selected={ isItemSelected }
                          style={ { ...isItemActive && { backgroundColor: getTheme().palette.secondary.light } } }
                        >
                          {showCheckbox && (
                            <StyledTableCell padding='checkbox'>
                              <Checkbox
                                onClick={ (event) => {
                                  return handleClick(event, row.id);
                                } }
                                checked={ isItemSelected }
                                inputProps={ { 'aria-labelledby': labelId } }
                              />
                            </StyledTableCell>
                          )}
                          {
                            columns.map((col) => {
                              let deepSelectorValue;

                              if (col.isQEdit === true) {
                                const formId = 'form_id'.split('.').reduce((acc, selector) => {
                                  return acc?.[selector];
                                }, row);

                                return (
                                  <StyledTableCell key={ col.id } align='left'>
                                    <a
                                      href={ `https://docs.google.com/forms/d/e/${ formId }/viewform` }
                                      target='_blank'
                                      rel='noreferrer'
                                    >
                                      Go to questionnaire
                                    </a>
                                  </StyledTableCell>
                                );
                              }

                              if (col.serial_payment_dropdown === true) {
                                return (
                                  <StyledTableCell
                                    key={ col.id }
                                    align='left'
                                    style={ {
                                      minWidth: '150px',
                                    } }
                                  >
                                    <SerialPaymentDropdown
                                      row={ row }
                                      field={ col.field }
                                      updateSerial={ col.updateSerial }
                                    />
                                  </StyledTableCell>
                                );
                              }

                              if (col.isCashStatus === true) {
                                return (
                                  <StyledTableCell
                                    key={ col.id }
                                    align='left'
                                    style={ {
                                      minWidth: '150px',
                                    } }
                                  >
                                    <div>
                                      {
                                        `Report paid: ${ row.serial_number_id.report_payment_status ?? 'none' }`
                                      }
                                    </div>

                                    <div>
                                      {
                                        `Kit paid: ${ row.serial_number_id.kit_payment_status ?? 'none' }`
                                      }
                                    </div>
                                  </StyledTableCell>
                                );
                              }

                              if (col.isAppointment === true) {
                                if (row?.metadata?.cashStatus === 'paid') {
                                  return (
                                    <StyledTableCell key={ col.id } align='center'>
                                      True
                                    </StyledTableCell>
                                  );
                                }

                                return (
                                  <StyledTableCell key={ col.id } align='center'>
                                    <FormControl>
                                      <Select
                                        value={ row?.appointment_availability }
                                        displayEmpty
                                        onChange={
                                          (e) => {
                                            setShowLoader(true);
                                            axiosClient.put(`registration-kits/admin-update/${ row.id }`, {
                                              appointmentAvailability: e.target.value,
                                            })
                                              .finally(() => {
                                                refetch().then(() => {
                                                  setShowLoader(false);
                                                });
                                              });
                                          }
                                        }
                                      >
                                        <MenuItem value={ null } disabled>Undefined</MenuItem>
                                        <MenuItem value='true'>True</MenuItem>
                                        <MenuItem value='false'>False</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </StyledTableCell>
                                );
                              }

                              // Change report language
                              if (col.kitLang === true) {
                                if (row.locale == null) {
                                  return (
                                    <StyledTableCell key={ row.id } />
                                  );
                                }

                                return (
                                  <StyledTableCell key={ col.id } align='left'>
                                    <FormControl>
                                      <Select
                                        value={ row?.locale }
                                        displayEmpty
                                        onChange={
                                          (e) => {
                                            setShowLoader(true);
                                            axiosClient.put(`registration-kits/admin-update/${ row.id }`, {
                                              registrationLocale: Number(e.target.value),
                                              registrationStatus: row.registrationStatus,
                                            }).finally(() => {
                                              axiosClient.post(`registration-kits/reportProcess/${ row.serial_number_id.serial }`).finally(() => {
                                                refetch().then(() => {
                                                  setShowLoader(false);
                                                });
                                              });
                                            });
                                          }
                                        }
                                      >
                                        <MenuItem value={ undefined } disabled>Undefined</MenuItem>
                                        <MenuItem value='3'>English</MenuItem>
                                        <MenuItem value='2'>Greek</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </StyledTableCell>
                                );
                              }

                              // if ('General Approve' === col.label && true === col.isDone) {
                              //   deepSelectorValue = !col.field ? null : col.field.split('.').reduce((acc, selector) => {
                              //     return acc?.[selector];
                              //   }, row);

                              //   const serial = 'id'.split('.').reduce((acc, selector) => {
                              //     return acc?.[selector];
                              //   }, row);

                              //   return (
                              //     <StyledTableCell key={ col.id } align='left'>
                              //       {
                              //         'done' !== deepSelectorValue && (
                              //           <IconButton onClick={ () => {
                              //             setShowLoader(true);
                              //             axiosClient.put(`registration-kits/admin-update/${ serial }`, {
                              //               registrationStatus: 'done',
                              //             }).finally(() => {
                              //               refetch().then(() => {
                              //                 setShowLoader(false);
                              //               });
                              //             });
                              //           } }
                              //           >
                              //             <CheckIcon />
                              //           </IconButton>
                              //         )
                              //       }
                              //     </StyledTableCell>
                              //   );
                              // }

                              if (null != col.downloadReport && true === col.downloadReport && 'Download Report' === col.label) {
                                if (null === row.serial_number_id.ancestor && (col.ngDownload
                                  || 'NutriGenetix-Laboratories' === row.thematic_package.thematic_category_id.name
                                  || 'NutriGenetix' === row.thematic_package.thematic_category_id.name)) {
                                  return (
                                    <StyledTableCell
                                      key={ col.id }
                                      align='center'
                                      style={ { paddingRight: '0px', paddingLeft: '0px' } }
                                    >
                                      <Button
                                        disabled={ !row.pdf_available }
                                        size='small'
                                        style={ {
                                          padding: '0 3px 0 3px',
                                          fontSize: '14px',
                                        } }
                                        variant='outlined'
                                        color='secondary'
                                        onClick={ () => { viewPDF(row, '_analysis.pdf'); } }
                                      >
                                        View analysis PDF
                                      </Button>

                                      <Button
                                        disabled={ !row.pdf_available }
                                        variant='outlined'
                                        size='small'
                                        style={ {
                                          padding: '0 3px 0 3px',
                                          fontSize: '14px',
                                        } }
                                        color='secondary'
                                        onClick={ () => { viewPDF(row, '_diet.pdf'); } }
                                      >
                                        View diet PDF
                                      </Button>
                                    </StyledTableCell>
                                  );
                                }

                                if ('PGx' === row.thematic_package.thematic_category_id.name) {
                                  return (
                                    <StyledTableCell
                                      key={ col.id }
                                      align='center'
                                      style={ { paddingRight: '0px', paddingLeft: '0px' } }
                                    >
                                      <Button
                                        disabled={ !row.pdf_available }
                                        style={ {
                                          padding: '0 3px 0 3px',
                                          fontSize: '14px',
                                        } }
                                        variant='outlined'
                                        color='secondary'
                                        onClick={ () => { viewPDF(row, '_doctor.pdf'); } }
                                      >
                                        View doctor&apos;s PDF
                                      </Button>

                                      <Button
                                        disabled={ !row.pdf_available }
                                        variant='outlined'
                                        style={ {
                                          padding: '0 3px 0 3px',
                                          fontSize: '14px',
                                        } }
                                        color='secondary'
                                        onClick={ () => { viewPDF(row, '.pdf'); } }
                                      >
                                        View customer&apos;s PDF
                                      </Button>
                                    </StyledTableCell>
                                  );
                                }

                                return (
                                  <StyledTableCell key={ col.id } align='center'>
                                    <Button
                                      disabled={ !row.pdf_available }
                                      variant='outlined'
                                      color='secondary'
                                      onClick={ () => { viewPDF(row, '.pdf'); } }
                                    >
                                      View PDF
                                    </Button>
                                  </StyledTableCell>
                                );
                              }

                              if (col.doneOrButton != null && col.doneOrButton === true) {
                                deepSelectorValue = !col.field ? null : col.field.split('.').reduce((acc, selector) => {
                                  return acc?.[selector];
                                }, row);

                                const serial = 'serial_number_id.serial'.split('.').reduce((acc, selector) => {
                                  return acc?.[selector];
                                }, row);

                                return (
                                  <StyledTableCell key={ col.id } align='left'>
                                    <DoneOrButton
                                      value={ deepSelectorValue }
                                      field={ col.field }
                                      serial={ serial }
                                      refetch={ refetch }
                                      setShowLoader={ setShowLoader }
                                    />
                                  </StyledTableCell>
                                );
                              }

                              if (col.isAddress != null && col.isAddress === true) {
                                deepSelectorValue = !col.field ? null : col.field.split('.').reduce((acc, selector) => {
                                  return acc?.[selector];
                                }, row);

                                if (deepSelectorValue != null) {
                                  if (typeof deepSelectorValue === 'string') {
                                    deepSelectorValue = JSON.parse(deepSelectorValue);
                                  }
                                  deepSelectorValue = `${ deepSelectorValue.streetAddress }, ${ deepSelectorValue.city }, ${ deepSelectorValue.postalCode }`;
                                }
                              } else if (col.complex != null && col.complex === true) {
                                deepSelectorValue = getConsentValue({ name: col.label }, row);
                              } else if (col.isDate != null && col.isDate === true) {
                                deepSelectorValue = !col.field ? null : col.field.split('.').reduce((acc, selector) => {
                                  return acc?.[selector];
                                }, row);

                                if (deepSelectorValue != null && deepSelectorValue !== '' && deepSelectorValue.length >= 10) {
                                  if (deepSelectorValue.length !== 10) {
                                    deepSelectorValue = deepSelectorValue.substring(0, deepSelectorValue.indexOf('T'));
                                  }
                                  deepSelectorValue = deepSelectorValue.split('-');
                                  deepSelectorValue = `${ deepSelectorValue[2] }/${ deepSelectorValue[1] }/${ deepSelectorValue[0] }`;
                                }
                              }

                              if (deepSelectorValue === undefined) {
                                deepSelectorValue = !col.field ? null : col.field.split('.').reduce((acc, selector) => {
                                  return acc?.[selector];
                                }, row);
                              }

                              const serial = 'id'.split('.').reduce((acc, selector) => {
                                return acc?.[selector];
                              }, row);

                              // eslint-disable-next-line react/display-name
                              const { customRenderer: CustomRenderer } = col;
                              return (
                                <StyledTableCell key={ col.id } align='left'>
                                  {CustomRenderer ? (
                                    <CustomRenderer
                                      id={ row.id }
                                      setShowLoader={ setShowLoader }
                                      refetch={ refetch }
                                      serial={ serial }
                                      value={ deepSelectorValue }
                                      row={ row }
                                    />
                                  ) : deepSelectorValue}
                                </StyledTableCell>
                              );
                            })
                          }
                          {showActions && (
                            <StyledTableCell align='right'>
                              <Grid container direction='column' alignItems='flex-end'>
                                <Grid item>
                                  <Grid container direction='row' alignItems='center'>
                                    {props.ViewProp?.handleView && (
                                      <Grid item>
                                        <AppIconView
                                          disabled={ props.ViewProp.disabledView }
                                          onClick={ (e) => {
                                            return props.ViewProp.handleView(e, row.id);
                                          } }
                                        />
                                      </Grid>
                                    )}
                                    {props.EditProp?.handleEdit && (
                                      <Grid item>
                                        <AppIconEdit
                                          disabled={ props.EditProp.disabledEdit }
                                          onClick={ (e) => {
                                            return props.EditProp.handleEdit(e, row.id);
                                          } }
                                        />
                                      </Grid>
                                    )}
                                    {props.DelProp?.handleDelete && (
                                      <Grid item>
                                        <AppIconDelete
                                          disabled={ props.DelProp.disabledDelete }
                                          onClick={ (e) => {
                                            return props.DelProp.handleDelete(e, row.id);
                                          } }
                                        />
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                              </Grid>
                            </StyledTableCell>
                          )}
                        </StyledTableRow>
                      );
                    })}
                </TableBody>
              )
            }
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={ [ 5, 10, 25, 100 ] }
          component='div'
          count={ count }
          rowsPerPage={ limit }
          page={ page }
          onChangePage={ (e, p) => {
            return setPage(p);
          } }
          onChangeRowsPerPage={ (e) => {
            return setLimit(parseInt(e.target.value, 10));
          } }
        />
      </Paper>
    </div>
  );
}
